export default "__VITE_ASSET__19a954ca__"